import { useSelector } from 'react-redux'
import { selectIsCoolingDown } from '../globalCooldownSlice.js'
import TeaserModal from './TeaserModal.js'

export default function GlobalCooldown () {
  const isCoolingDown = useSelector(selectIsCoolingDown)
  return <TeaserModal isOpen={isCoolingDown} heading='Bel is busy, come back later...' />
}
